// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { DataCacheToolRayType, DataCacheToolType } from '../DataCacheToolEnums';
import { Color, PenStyle } from '../../../Commons/Graphics';
import { DataCacheTool } from '../DataCacheTool';
import { DynProperty, ColorStyleWidth } from '../../DynProperty';
export class AndrewsPitchforkDataCacheTool extends DataCacheTool {
    constructor() {
        super();
        this.InitBlock();
    }
    get DashedPen() {
        return this.dashedPen;
    }
    InitBlock() {
        super.InitBlock();
        this.ToolType = DataCacheToolType.AndrewsPitchFork;
        this.InitPoints(3);
        this.RayType = DataCacheToolRayType.Ray;
        this.dashedPen = this.Pen.copy();
        this.dashedPen.DashStyle = PenStyle.DotChart;
    }
    MinPointsCount() {
        return 3;
    }
    MaxPointsCount() {
        return 3;
    }
    Properties() {
        const props = super.Properties();
        const colorStyleWidthRays = new ColorStyleWidth(Color.Empty, this.styleRay, 1);
        colorStyleWidthRays.enableStyleOnly();
        const prop = new DynProperty('Ray style', colorStyleWidthRays, DynProperty.COLOR_STYLE_WIDTH, DynProperty.VISUAL_GROUP);
        prop.propertyComment = Resources.getResource('property.chart.rayStyle');
        props.push(prop);
        return props;
    }
    callBack(properties) {
        super.callBack(properties);
        const prop = DynProperty.getPropertyByName(properties, 'Ray style');
        if (prop != null)
            this.StyleRay = prop.value.Style;
    }
}
